import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CheckboxGroupTags from 'components/search_page/checkbox_group_tags';
import CurrentFilters from 'components/search_page/current_filters';
import FilterButton from 'shared/filter_button';
import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';
import ManagedInput from 'components/form/managed_input';
import Query from 'components/search_sidebar/sidebar_search';

import {
  changeEventTypeFilter,
  changeStatusFilter,
  changeSearchText,
  clearFilters,
  changeMaxDateFilter,
  changeMinDateFilter
} from './store/actions/query';

import { filterLabelMappings } from './webhook_event_filter_constants';

const statuses = [
  { id: 'success', label: 'Success', value: '2', className: 'd-flex align-items-center gap-2' },
  { id: 'error', label: 'Error', value: '1', className: 'd-flex align-items-center gap-2' },
  { id: 'received', label: 'Received', value: '0', className: 'd-flex align-items-center gap-2' }
];

export class WebhookEventFilterTopbar extends React.Component {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    eventTypeFilter: PropTypes.array.isRequired,
    eventTypes: PropTypes.array.isRequired,
    maxDate: PropTypes.instanceOf(Date).isRequired,
    minDate: PropTypes.instanceOf(Date).isRequired,
    pageSize: PropTypes.number.isRequired,
    searchText: PropTypes.string.isRequired,
    statusFilter: PropTypes.array.isRequired,
    totalCount: PropTypes.number.isRequired,
    webhookEventCount: PropTypes.number.isRequired,
    onChangeMaxDateFilter: PropTypes.func.isRequired,
    onChangeMinDateFilter: PropTypes.func.isRequired,
    onChangeEventTypeFilter: PropTypes.func.isRequired,
    onChangeSearchText: PropTypes.func.isRequired,
    onChangeStatusFilter: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired
  };

  handleSearchChange = (e) => {
    this.props.onChangeSearchText(e.target.value);
  };

  handleCheckboxGroupChange = (e, name) => {
    const { checked, value } = e.target;
    const { filterKey, onChange } = this.filterMapping[name];
    const filter = [...this.props[filterKey]].filter(selected => selected !== value);
    if (checked) filter.push(value);

    onChange(filter);
  };

  handleEventTypeChange = (e) => {
    this.handleCheckboxGroupChange(e, 'eventType');
  };

  handleStatusChange = (e) => {
    this.handleCheckboxGroupChange(e, 'status');
  };

  filterMapping = {
    eventType: {
      filterKey: 'eventTypeFilter',
      handleChange: this.handleEventTypeChange,
      onChange: this.props.onChangeEventTypeFilter,
      options: this.props.eventTypes.map(type => ({
        id: type, label: type, value: type, className: 'd-flex align-items-center gap-2',
      }))
    },
    status: {
      filterKey: 'statusFilter',
      handleChange: this.handleStatusChange,
      onChange: this.props.onChangeStatusFilter,
      options: statuses
    }
  };

  render() {
    return (
      <div>
        {this.renderFilters()}
        <CurrentFilters onClearFilters={this.props.onClearFilters}>
          {this.renderTags()}
        </CurrentFilters>
      </div>
    );
  }

  renderFilters() {
    const pageData = {
      currentPage: this.props.currentPage,
      itemCount: this.props.webhookEventCount,
      itemSingularLabel: 'webhook event',
      pageSize: this.props.pageSize,
      totalCount: this.props.totalCount,
    };

    return (
      <div className="d-flex align-items-center flex-wrap gap-3">
        <Query
          placeholder="Search by identifier or request"
          style={{ width: 240 }}
          value={this.props.searchText}
          onChange={this.handleSearchChange}
        />
        {this.renderCheckboxGroupFilter('status')}
        {this.renderCheckboxGroupFilter('eventType')}
        <div className="d-flex align-items-center gap-3">
          <ManagedInput
            className="datetime-picker form-control"
            name="createdMinDate"
            placeholder="Received At Date"
            showTimeSelect
            type="date"
            value={this.props.minDate}
            onValueChange={this.props.onChangeMinDateFilter}
          />
          <div>TO</div>
          <ManagedInput
            className="datetime-picker form-control"
            name="createdMaxDate"
            placeholder="Received At Date"
            showTimeSelect
            type="date"
            value={this.props.maxDate}
            onValueChange={this.props.onChangeMaxDateFilter}
          />
        </div>
      </div>
    );
  }

  renderCheckboxGroupFilter(name) {
    const { filterKey, handleChange, options } = this.filterMapping[name];
    const filter = this.props[filterKey];

    return (
      <FilterButton filtersApplied={filter.length > 0} label={filterLabelMappings[name]} name={name}>
        <FilterCheckboxGroup
          name={`${name}InputGroup`}
          options={options}
          selected={filter}
          onChange={handleChange}
        />
      </FilterButton>
    );
  }

  renderTags() {
    const tags = [];
    this.renderCheckboxGroupTags(tags, 'status');
    this.renderCheckboxGroupTags(tags, 'eventType');

    return tags;
  }

  renderCheckboxGroupTags(tags, name) {
    const { filterKey, handleChange, options } = this.filterMapping[name];
    const filter = this.props[filterKey];
    if (filter.length === 0) return;

    const label = filterLabelMappings[name];

    tags.push(
      <CheckboxGroupTags
        filter={filter}
        key={`${name}_tags`}
        label={label}
        name={name}
        options={options}
        onRemove={handleChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  ...state.search.meta,
  ...state.query,

  webhookEventCount: state.search.webhookEvents.length
});

const mapDispatchToProps = {
  onChangeMinDateFilter: changeMinDateFilter,
  onChangeMaxDateFilter: changeMaxDateFilter,
  onChangeEventTypeFilter: changeEventTypeFilter,
  onChangeStatusFilter: changeStatusFilter,
  onChangeSearchText: changeSearchText,
  onClearFilters: clearFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(WebhookEventFilterTopbar);
